import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CurrencyService } from '../services/currency.service';

export const currencyInterceptor: HttpInterceptorFn = (req, next) => {
  const currencyService = inject(CurrencyService);
  const currentCurrency = currencyService.getCurrentCurrency();

  // Clone the request and add the currency header
  const clonedRequest = req.clone({
    setHeaders: {
      'x-currency': currentCurrency,
    },
  });

  return next(clonedRequest);
};
